import { getFileDownloadUrl, getFileUploadUrl } from "./signedURL";
import stageConfig from "../stageConfig.json";

const apiUrl = `https://ctt64g6v42.execute-api.us-east-1.amazonaws.com/${stageConfig.stage}`;

export const tickerData = async (auth, ticker, tickerStorage) => {
  if (ticker in tickerStorage) {
    return tickerStorage[ticker];
  }
  const bucket = "vecviz-ticker-json";
  const filepath = `ticker/${ticker}.json`;

  const signedUrl = await getFileDownloadUrl(
    auth,
    filepath,
    bucket,
    "signedurl"
  );

  const cleanNegativeData = (val) => {
    if (val.includes("(")) {
      const newval = val
        .split("(")
        .join("")
        .split(")")
        .join("")
        .split(",")
        .join("");
      return +newval * -1;
    } else {
      return +val.split(",").join("");
    }
  };
  const data = await fetch(signedUrl)
    .then((res) => res.json())
    .then((data) => {
      return data.map((item) => {
        return {
          ...item,
          Px: cleanNegativeData(item.Px),
          VecLevel: +item.VecLevel,
        };
      });
    })
    .catch((err) => {
      console.log(err.message);
      });
  tickerStorage[ticker] = data;
  return data;
};

export const storedValueData = async (auth, ticker, storedValueStorage) => {
  if (ticker in storedValueStorage) {
    return storedValueStorage[ticker];
  }
  const bucket = "vecviz-ticker-json";
  const filepath = `storedvalue/${ticker}.json`;

  const signedUrl = await getFileDownloadUrl(
    auth,
    filepath,
    bucket,
    "signedurl"
  );

  const cleanNegativeData = (val) => {
    if (val.includes("(")) {
      const newval = val
        .split("(")
        .join("")
        .split(")")
        .join("")
        .split(",")
        .join("");
      return +newval * -1;
    } else {
      return +val.split(",").join("");
    }
  };
  const data = await fetch(signedUrl)
    .then((res) => res.json())
    .then((data) => {
      return data.map((item) => {
        return {
          ...item,
          Px: cleanNegativeData(item["Expected Px"]),
        };
      });
    })
    .catch((err) => {
      console.log(err.message);
    });

  storedValueStorage[ticker] = data;
  return data;
};

export const UploadDocument = async (auth, filename, file) => {
  const bucket = "vecviz-images";
  const filepath = filename;

  const signedPost = await getFileUploadUrl(
    auth,
    filepath,
    bucket,
    "signedpost"
  );
  const fields = signedPost["fields"];
  const url = signedPost["url"];
  const formData = new FormData();
  Object.keys(fields).forEach((key) => formData.append(key, fields[key]));
  formData.append("file", file);

  try {
    const config = {
      method: "POST",
      body: formData,
    };
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return "success";
  } catch (err) {
    return err.message;
  }
};

export const spiderData = async (auth, tickerStorage) => {
  if ("spider" in tickerStorage) {
    return tickerStorage["spider"];
  }
  const bucket = "vecviz-ticker-json";
  const filepath = "spider/spider.json";

  try {
    const signedUrl = await getFileDownloadUrl(
      auth,
      filepath,
      bucket,
      "signedurl"
    );

    const response = await fetch(signedUrl);
    if (!response.ok) {
      console.error(`Failed to fetch spider data: ${response.status} ${response.statusText}`);
      return [];
    }
    const data = await response.json();
    tickerStorage["spider"] = data;
    return data;
  } catch (error) {
    console.error("Error fetching spider data:", error.message);
    return [];
  }
};

export const fairvalueData = async (auth, tickerStorage) => {
  if ("fairvalue" in tickerStorage) {
    return tickerStorage["fairvalue"];
  }
  const bucket = "vecviz-ticker-json";
  const filepath = "fairvalue/fairvalue.json";

  try {
    const signedUrl = await getFileDownloadUrl(
      auth,
      filepath,
      bucket,
      "signedurl"
    );

    const response = await fetch(signedUrl);
    if (!response.ok) {
      console.error(`Failed to fetch fairvalue data: ${response.status} ${response.statusText}`);
      return [];
    }
    const data = await response.json();
    tickerStorage["fairvalue"] = data;
    return data;
  } catch (error) {
    console.error("Error fetching fairvalue data:", error.message);
    return [];
  }
};

export const vsfpData = async (auth, tickerStorage) => {
  if ("vsfp" in tickerStorage) {
    return tickerStorage["vsfp"];
  }
  const bucket = "vecviz-ticker-json";
  const filepath = "vsforwardperformance/vsforwardperformance.json";

  try {
    const signedUrl = await getFileDownloadUrl(
      auth,
      filepath,
      bucket,
      "signedurl"
    );

    const response = await fetch(signedUrl);
    if (!response.ok) {
      console.error(`Failed to fetch VSFP data: ${response.status} ${response.statusText}`);
      return [];
    }
    const data = await response.json();
    tickerStorage["vsfp"] = data;
    return data;
  } catch (error) {
    console.error("Error fetching VSFP data:", error.message);
    return [];
  }
};

let tickerListCache = null;

const fetchTickerList = async (auth) => {
  if (tickerListCache) {
    return tickerListCache;
  }

  const bucket = "vecviz-ticker-json";
  const filepath = "ticker-list.json";

  const signedUrl = await getFileDownloadUrl(auth, filepath, bucket, "signedurl");
  const data = await fetch(signedUrl).then((res) => res.json());

  tickerListCache = data;
  return data;
};

export const listTickerData = async (auth, tickerStorage, path) => {
  const cacheKey = `MENUITEMS_${path || 'all'}`;

  if (cacheKey in tickerStorage) {
    return tickerStorage[cacheKey];
  }

  try {
    const tickerList = await fetchTickerList(auth);

    let list;
    if (path === "ticker/") {
      list = tickerList.tickers || [];
    } else if (path === "storedvalue/") {
      list = tickerList.storedvalue || [];
    } else {
      list = tickerList.tickers || [];
    }

    tickerStorage[cacheKey] = list;
    return list;
  } catch (err) {
    console.log("Error fetching ticker list:", err.message);
    return [];
  }
};

export async function saveDefaultLayout(auth, id) {
  const token = await auth.getToken();
  const response = await fetch(`${apiUrl}/defaultlayout`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: id,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}

export const getConfig = async (auth) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/config`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};

export const getLayoutList = async (auth) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/listlayout`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};
